export class CabeceraVehiculosExclusionEntity
    {
        constructor(
        public CodigoUsuario?: number,
        public CodigoPoliza?: string,
        public CodigoCiudad?: number,
        public CodigoRamo?: string,
        public CodigoAseguradora?: number,
        public RolEmpleado?: number,
        public CodigoUnidad?: number,        
        public CodigoCliente?: number,
        public VehiculosExclusion?: VehiculosExclusionEntity[],
        public Observaciones?: string
        
        ){}        
    }

export class VehiculosExclusionEntity
    {
        constructor(
        public Marca?: string,
        public Modelo?: string,
        public Motor?: string,
        public Chasis?: string,
        public Placa?: string,
        public CodigoVehiculo?: number,
        public EstadoSolicitud?: number,
        public EstadoActual?: number
        ){}        
    }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/vehiculos_exclusion_entity.ts